module.exports = __webpack_public_path__ + "img/PERMATA.245ea28d.svg";